<div class="custom-strategy-options-edit">
    <div class="form-control">
        @if (IsConfigurable()) {
            <button mat-flat-button class="rounded-1" (click)="addField()">Add Field</button>
        }

        @if (options.fields && options.fields.length > 0) {
            <table class="table table-striped table-bordered table-hover">
                <thead>
                    <tr>
                        <th scope="col">Field Name</th>
                        <th scope="col">Type</th>
                        <th scope="col">Value</th>
                        @if (IsConfigurable()) {
                            <th scope="col"></th>
                        }
                    </tr>
                </thead>
                <tbody>
                    @for (field of options.fields; track $index) {
                        <tr>
                            <td>
                                @if (IsConfigurable()) {
                                    <input
                                        type="text"
                                        class="col-12"
                                        [(ngModel)]="field.name"
                                        (ngModelChange)="onFieldChange()"
                                        placeholder="Field name"
                                    />
                                } @else {
                                    <span class="field-name">{{ field.name }}</span>
                                }
                            </td>
                            <td>
                                @if (IsConfigurable()) {
                                    <mat-form-field class="w-100">
                                        <mat-select [(ngModel)]="field.type" (ngModelChange)="onFieldChange()">
                                            @for (type of fieldTypes; track type) {
                                                <mat-option [value]="type">{{ type }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                } @else {
                                    <span class="field-type">{{ field.type }}</span>
                                }
                            </td>
                            <td>
                                @if (isFieldBoolean(field.type)) {
                                    <mat-form-field class="w-100">
                                        <mat-select [(ngModel)]="field.value" (ngModelChange)="onFieldChange()">
                                            <mat-option value="true">true</mat-option>
                                            <mat-option value="false">false</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                } @else {
                                    <input
                                        [type]="getFieldInputType(field.type)"
                                        class="col-12"
                                        [(ngModel)]="field.value"
                                        (ngModelChange)="onFieldChange()"
                                        placeholder="Value"
                                    />
                                }
                            </td>
                            @if (IsConfigurable()) {
                                <td>
                                    <button
                                        mat-icon-button
                                        color="warn"
                                        class="rounded-1"
                                        (click)="removeField($index)"
                                    >
                                        <fa-icon [icon]="['fas', 'trash']" />
                                    </button>
                                </td>
                            }
                        </tr>
                    }
                </tbody>
            </table>
        }
    </div>
</div>
